export default __webpack_public_path__ + "16481cf740d5ad57d23949dd60e4d934.svg";